/**
 * move breadcrumbs to top of page
 */
(() => {
  const pdpPage = document.querySelector('.ex-product');
  if (!pdpPage) return;

  const breadcrumb = pdpPage.querySelector('.row-breadcrumb');
  pdpPage.querySelector('.zonetop').append(breadcrumb);
})();

/**
 * Move logo to image
 */
const moveLogo = () => {
  const mainBrandLogo = document.querySelectorAll('.product-summary .product-brand');
  mainBrandLogo.forEach((item) => {
    const mainImage = item.closest('.catalog-single').querySelector('.main-image');
    mainImage.append(item);
  });
};

/**
 * animation add to cart
 */
(() => {
  const addToCart = document.querySelector('.mainproductpagedesktop .filter-container');
  if (!addToCart) return;
  setTimeout(() => {
    addToCart.classList.add('nLoaded');
  }, 2000);
})();

/**
 * Product Indicators Wrap & Text
 */
const wrapProductIndicators = () => {
  document.querySelectorAll('.productdetails').forEach((product) => {
    let count = 0;
    product.querySelectorAll('.product-indicators > i').forEach((indicator) => {
      const title = indicator.getAttribute('data-original-title') || indicator.getAttribute('title');
      const indicatorWrap = document.createElement('div');
      indicatorWrap.className = 'indicator-wrap';
      indicatorWrap.append(indicator);
      indicatorWrap.insertAdjacentHTML('beforeend', `<span>${title}</span>`);
      product.querySelector('.product-indicators').append(indicatorWrap);
      count += 1;
    });
    if (count === 0) {
      const productIndicators = product.querySelector('.product-indicators');
      if (!productIndicators) return;
      productIndicators.remove();
    }
  });
};

const wrapProdTools = () => {
  document.querySelectorAll('.product-shopping-actions-addtoquicklist').forEach((item) => {
    const w1 = item.parentElement;
    const w2 = item.closest('.product-shopping-actions').querySelector('.product-compare-action');
    const prodToolsWrap = document.createElement('div');
    prodToolsWrap.classList.add('prodToolsWrap');
    w1.parentNode.insertBefore(prodToolsWrap, w1);
    prodToolsWrap.append(w1);
    prodToolsWrap.append(w2);
  });
};

const moveMinOrder = () => {
  (() => {
    const minOrder = document.querySelector('.productdetails .min-order');
    const cartWrapper = document.querySelector('.product-shopping-actions-addtocart');
    if (!minOrder || !cartWrapper) return;
    cartWrapper.prepend(minOrder);
  })();

  (() => {
    const mobileMinOrder = document.querySelector('.mainproductpagemobile .min-order');
    const mobileCartWrapper = document.querySelector('.mainproductpagemobile .product-shopping-actions-addtocart');
    if (!mobileMinOrder || !mobileCartWrapper) return;
    mobileCartWrapper.prepend(mobileMinOrder);
  })();
};

/**
 * Move Manufacturer Ref
 */
(() => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  document.querySelectorAll('.productdetails').forEach((prodDetails) => {
    const manuRef = prodDetails.querySelector('.manufacturer-ref');
    const sku = prodDetails.querySelector('.prod-code');

    if (sku && manuRef) {
      sku.append(manuRef);
    }
  });
})();

/**
 * Fix arrows from product tabs
 */
const collapseTabEvent = () => {
  (() => {
    const hasLiveInventory = document.querySelector('.dds-specs-description');
    if (!hasLiveInventory) return;

    if (hasLiveInventory) {
      const config = { attributes: true };
      const observer = new MutationObserver(() => {
        // prevent feature and spec from opening on start along with description
        const panelCollapse = document.querySelectorAll('.dds-specs-description .panel-collapse');
        if (!panelCollapse.length) return;

        panelCollapse.forEach((collapse) => {
          collapse.classList.remove('in');
        });

        // click on the dds panels to change arrow
        const panelHeading = document.querySelectorAll('.panel-heading');
        if (!panelHeading.length) return;

        panelHeading.forEach((title) => {
          title.classList.add('collapsed');

          title.addEventListener('click', () => {
            title.classList.toggle('collapsed');
          });
        });
      });

      observer.observe(hasLiveInventory, config);
    }
  })();
};

/**
 * move pdf spc sheet into prod details
 */
(() => {
  const observeSpecSheet = (selector, wrapperSelector) => {
    const specSheet = document.querySelector(selector);
    if (!specSheet) return;

    const config = { attributes: true };
    const observer = new MutationObserver(() => {
      document.querySelector(wrapperSelector).append(specSheet);
    });

    observer.observe(specSheet, config);
  };

  observeSpecSheet('.desktop .dds-specs-image', '.desktop .product-details-wrapper');
  observeSpecSheet('.mobile .dds-specs-image', '.mobile .product-details-wrapper');
})();

/**
 * call for availability button replace add to cart
 */
(() => {
  const updateButton = (selectorPrefix) => {
    const button = document.querySelector(`${selectorPrefix} .product-shopping-actions-addtocart .buttons.group button`);
    const input = document.querySelector(`${selectorPrefix} .product-shopping-actions-addtocart .buttons.group .qnt-count`);
    const outOfStock = document.querySelector(`${selectorPrefix} .live-stock-content.out-stock .live-outstock`);
    if (button && outOfStock) {
      button.innerHTML = 'Call for Availability';
      button.classList.add('call-for-availability');
      outOfStock.innerHTML = 'Out of Stock';
      if (input) {
        input.remove();
      }
    }
  };

  const observeTargetNode = (selectorPrefix) => {
    const targetNode = document.querySelector('.has-live-inventory');
    if (targetNode) {
      const config = { attributes: true };
      const observer = new MutationObserver(() => {
        updateButton(selectorPrefix);
      });
      observer.observe(targetNode, config);
    }
  };

  observeTargetNode('.desktop');
  observeTargetNode('.mobile');

  // ** Replaces images that have not loaded PDP
  (() => {
    const imageError = () => {
      const placeholderUrl = 'https://us.evocdn.io/dealer/1407/content/media/My_Theme/ke-coming-soon-image.png'; // make sure this url works
      const images = document.querySelectorAll('.main-image img');
      images.forEach((image) => {
        if (image.src === 'https://keencompressedgas.us.evostore.io/img/picture-100.png') {
          image.src = placeholderUrl;
          image.style.padding = '60px';
        }
      });
    };
    document.addEventListener('product-loadmore-success', () => {
      setTimeout(() => { // To stop the code bugging out and replacing all images with the placeholder
        imageError();
      }, 10);
    }, false);
    document.addEventListener('live-inventory-done', () => { // Run code when inventory has loaded
      setTimeout(() => {
        imageError();
      }, 10);
    }, false);
    // setTimeout(() => { // Fallback in case inventory is removed
    //   imageError();
    // }, 100);
  })();
})();

const pdpInitFunctions = () => {
  wrapProductIndicators();
  wrapProdTools();
  moveMinOrder();
  collapseTabEvent();
};

/**
 * init
 */
(() => {
  const query = document.querySelector('.ex-product');
  if (!query) return;

  pdpInitFunctions();
})();

window.evoXProductChangeCallback = () => {
  pdpInitFunctions();
};

(() => {
  // Select the node that will be observed for mutations
  const targetNode = document.body.querySelector('.has-live-inventory');

  if (targetNode) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true };

    // Callback function to execute when mutations are observed
    const observer = new MutationObserver(() => {
      moveLogo();
    });

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
})();

/**
 * move disclaimer  below image
 */
(() => {
  document.addEventListener('dds-specs-success', () => {
    setTimeout(() => {
      const disclaimer = document.querySelector('.prod-image-disclaimer');
      document.querySelectorAll('.ex-product .main-image > .row')
        .forEach((image) => {
          if (!disclaimer) return;
          image.append(disclaimer.cloneNode(true));
        });

      document.querySelectorAll('.ex-product .main-image > .prod-gal')
        .forEach((image) => {
          if (!disclaimer) return;
          image.append(disclaimer.cloneNode(true));
        });
    }, 1000);
  }, false);
})();
